import { LandingComponent } from "./LandingComponent";
export default LandingComponent;
